import React, { useEffect, useState } from 'react';
import PageHeader from '../components/PageHeader';
import { getContentByCategory } from '../services/api';

const TOPICS = [
  'Dismissal', 'Suspension', 'Contracts', 'Minimum Wage', 'Overtime', 'Working Hours',
  'Leave', 'UIF', 'COIDA', 'Payslips', 'Disciplinary Hearings', 'Retrenchments',
  'Workplace Discrimination', 'Harassment', 'Unfair Labour Practices',
];

export default function RightsLibrary() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    getContentByCategory('RIGHTS_LIBRARY')
      .then((res) => setArticles(res.data))
      .catch(() => setArticles([]));
  }, []);

  return (
    <div>
      <PageHeader
        eyebrow="Workers' Rights Library"
        title="Know Your Rights"
        subtitle="Educational articles covering the topics that matter most to South African workers. This library grows continuously."
      />
      <section className="section">
        <div className="container grid grid-3">
          {TOPICS.map((topic) => (
            <div className="card" key={topic}>
              <h3>{topic}</h3>
              <p>Plain-language guidance on your rights and obligations regarding {topic.toLowerCase()}.</p>
            </div>
          ))}
        </div>

        {articles.length > 0 && (
          <div style={{ marginTop: 48 }}>
            <h2>Latest Articles</h2>
            <div className="grid grid-3">
              {articles.map((a) => (
                <div className="card" key={a.id}>
                  <h3>{a.title}</h3>
                  <p>{a.content?.slice(0, 140)}...</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
